import React, {useLayoutEffect, useRef, useSyncExternalStore} from 'react';
import {useRootElement} from '../../Utilities';
import PortalTo from '../../Utilities/PortalTo';
import {fadeFrames, optionsIn, optionsOut} from './dialogAnimations';
import type {DialogsRegistry} from './DialogsRegistry';

export function DialogsBackdrop({registry}: {registry: DialogsRegistry}) {
    const isShown = useSyncExternalStore(registry.subscribe, registry.hasOpenDialog);
    const rootElement = useRootElement();

    const ref = useRef<HTMLDivElement>(null);
    const animation = useRef<Animation>();

    useLayoutEffect(() => {
        const el = ref.current;
        if (!el) return;

        animation.current?.cancel();

        if (isShown) {
            el.style.display = 'unset';
        }

        const anim = el.animate(fadeFrames, isShown ? optionsIn : optionsOut);
        animation.current = anim;

        if (!isShown) {
            anim.onfinish = () => {
                el.style.display = 'none';
            };
        }
    }, [isShown]);

    return (
        <PortalTo element={rootElement}>
            <div ref={ref} aria-hidden className='absolute inset-0 z-40 hidden bg-shade-70 opacity-0' />
        </PortalTo>
    );
}
